<template>
    <div>
        <div class="container">
            <h1>Služby</h1>
            <div class="sluzby-wrapper">
            <ul class="sluzby-list">
                <li 
                    v-for="sluzba in sluzby" 
                    :key="sluzba.id"
                    @click="zobrazitDetailSluzby(sluzba)"
                >
                    <div class="sluzby-list-item">
                        <span class="sluzby-list-title">{{ sluzba.name }}</span>
                        <span 
                            v-if="sluzba.tags"
                            class="sluzby-list-tags"
                        >
                            <span
                                v-for="tag in sluzba.tags"
                                :key="tag"
                                class="sluzby-list-tag"
                            >
                               {{ tag }} 
                            </span>
                        </span>
                    </div>
                </li>
            </ul>
        </div>
        <div>
            <!-- <p>{{ JSON.parse(sluzby_list) }}</p>
            <p>{{ sluzby }}</p> -->
        </div>
        </div>
        <div id="detail-sluzby-side-shadow"></div>
        <div id="detail-sluzby-side" class="detail-sluzby">
            <div class="detail-sluzby-controls">
                <div 
                    style="position:relative;width:20px;height: 20px;"
                    @click="skrýtDetalSluzby()"
                    class="detail-sluzby-close-btn"
                >
                    <span class="ox-toggler__bar" style="position:absolute; transform: rotate(-45deg);top:50%;left:0;"></span>
                    <span class="ox-toggler__bar" style="position:absolute; transform: rotate(45deg);top:50%;left:0;"></span>
                </div>
            </div>
            <sluzba-detail :sluzba="this.detailSluzby"></sluzba-detail>
        </div>
    </div>
</template>

<script>
import SluzbaDetail from './SluzbaDetail.vue';
    export default {
        components: { SluzbaDetail },
        props: {
            sluzby_list: {
                type: Object,
                // default: {
                //     name: "",
                // }
            },
        },
        data() {
            return {
                sluzby: [
                    {   
                        id: 1,
                        name: "Aplikace a Appky",
                        url: "aplikace-a-Appky",
                    },
                    {   
                        id: 2,
                        name: "Automatizace",
                        url: "automatizace",
                    },
                    {   
                        id: 3,
                        name: "Brand a Identita",
                        url: "brand-a-identita",
                    },
                    {   
                        id: 4,
                        name: "E-shopy",
                        url: "e-shopy",
                    },
                    {   
                        id: 5,
                        name: "Integrace",
                        url: "integrace",
                    },
                    {   
                        id: 6,
                        name: "Logo a Logotyp",
                        url: "logo-a-logotyp",
                    },
                    {   
                        id: 7,
                        name: "Microsites",
                        url: "microsites",
                    },
                    {   
                        id: 8,
                        name: "Obalový design",
                        url: "obalovy-design",
                    },
                    {   
                        id: 9,
                        name: "Obsahová strategie",
                        url: "obsahova-strategie",
                        tags:[
                            'Novinka',
                            'Valuepack'
                        ]
                    },
                    {   
                        id: 10,
                        name: "Print",
                        url: "print",
                    },
                    {   
                        id: 11,
                        name: "SEO",
                        url: "seo",
                    },
                    {   
                        id: 12,
                        name: "Weby",
                        url: "weby",
                    },
                ],
                detailSluzby: null,
            }
        },
        methods: {
            zobrazitDetailSluzby(sluzba) {
                this.detailSluzby = sluzba;
                window.history.replaceState(null, null, `/${sluzba.url}`)
                document.getElementById("detail-sluzby-side").classList.add("active")
                document.getElementById("detail-sluzby-side-shadow").classList.add("active")
            },
            skrýtDetalSluzby(){
                window.history.pushState(null, null, `/sluzby`)
                document.getElementById("detail-sluzby-side").classList.remove("active")
                document.getElementById("detail-sluzby-side-shadow").classList.remove("active")
            }
        },
    }
</script>

<style lang="scss" scoped>
.sluzby-list{
    list-style: none;
    padding: 0px;
    margin: 0px auto;
    margin-bottom: 90px;
    li{
        width: 100%;
        border-bottom: solid 1px rgba(0, 0, 0, 0.2);
        padding: 40px 0px;
        cursor: pointer;
        .sluzby-list-item{
            display: flex;
        }
        .sluzby-list-title{
            font-size: 80px;
            font-weight: 600;
        }
    }
}
.sluzby-list-tags{
    margin-left: 20px;
    margin-top: 30px;
    display: flex;
    gap: 5px;
    .sluzby-list-tag{
        font-size: 16px;
        font-weight:600;
        line-height: 1.33;
        padding: 1px 7px;
        color: white;
        background-color: rgb(117, 0, 128);
        align-self: flex-start;
    }
}
#detail-sluzby-side-shadow{
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100vw;
    height: 100vh;
    background-color: rgba(200, 200, 200, 0);
    display: none;
    backdrop-filter: blur(0px);
    // transition: background-color 1s;
    &.active{
        display: block;
        background-color: rgba(200, 200, 205, 0.5);
        backdrop-filter: blur(10px);
    }
}
.detail-sluzby{
    position: fixed;
    z-index: 10;
    top: 0px;
    right: 0px;
    width: 50vw;
    height: 100vh;
    background-color: white;
    transform: translateX(100%);
    transition: all .3s;
    padding: 30px 90px;
    &.active{
        transform: translateX(0px);
    }
    .detail-sluzby-controls{
        margin-bottom: 60px;
    }
    .detail-sluzby-close-btn{
        cursor: pointer;
    }
}
</style>